@if (actionButtons || showColumnSelection || !hideColumnSearchFunctionality) {
  <action-buttons #actionButtonsComponent [columns]="columns" [actionButtons]="actionButtons"
    [showColumnSelection]='showColumnSelection' (onColumnsChange)="onColumnsChanged($event)"
  [hideColumnSearchFunctionality]='hideColumnSearchFunctionality' [columnSearchActive]='showColumnSearchFields' (onHideColumnSearchFunctionalityChange)="onHideColumnSearchFunctionalityChange()"></action-buttons>
}

@if (filter && showFilter && !showColumnSearchFields) {
  <div class="flex-container">
    <ng-container *ngTemplateOutlet="quickFilterTemplate"></ng-container>
  </div>
}
<div class="line-separator"></div>

@if (tableColumns.length === 0 && !loadingInProgress) {
  <div class="no-columns-selected-message">{{'Admin.Datatable.NoColumnsSelected' | translate}}</div>
}
<ngx-datatable [id]='guid' #table [loadingIndicator]="loadingInProgress" class="material" [rows]="tableRows" [columns]="tableColumns"
  [style.display]="tableColumns.length === 0 && !loadingInProgress ? 'none' : ''"
  [count]="totalNumberOfRecords" [columnMode]="columnMode" [rowHeight]="'auto'" [limit]='filter?.pager?.itemsPerPage' [headerHeight]="$any(hideHeader ? '0' : 'auto')"
  [scrollbarH]='$any(scrollbarH)' [footerHeight]="$any('auto') " [externalSorting]="true" (sort)="onSort($event)" [reorderable]="false" [rowClass]='getRowClass'>
  <ngx-datatable-footer>
    <ng-template ngx-datatable-footer-template>
      @if (showPager && tableRows.length !== 0) {
        <!-- Pager -->
        <div class="pager-container">
          @if (showNumberOfItemsPerPage) {
            <div class="items-per-page-container">
              <span>{{'Admin.Pager.Showing' | translate}}</span>
              <div class="fiori3-input-group fiori3-select-group">
                <select id="itemsPerPageDropdown" class="form-control items-per-page-select" (change)='itemsPerPageChanged()' [(ngModel)]='filter.pager.itemsPerPage'>
                  <option value='10'>10</option>
                  <option value='20'>20</option>
                  <option value='100'>100</option>
                  <option value='200'>200</option>
                  <option value='500'>500</option>
                </select>
              </div>
              <span id="totalNumberOfRecords">/ {{totalNumberOfRecords}} {{'Admin.Pager.Items' | translate}}</span>
            </div>
          }
          <div class="pagination-container fiori3-input-group">
            <button type="button" id="firstPageButton" class="sap-icon" [disabled]="currentPage <= 1" (click)="onFirstLastPage(true)">
              &#xe14e;
            </button>
            <button type="button" id="previousPageButton" class="sap-icon" [disabled]="currentPage <= 1" (click)="onPage(false)">
              &#xe067;
            </button>
            <span>{{'Admin.Pager.Page' | translate}}</span>
            <input id="pageNumberInput" class="form-control" [(ngModel)]='currentPage' (keyup.enter)="goToPage()">
            <span> {{totalNumberOfRecords > filter.pager.itemsPerPage && showTotalNumbers ? '/ ' + totalPages : '/ 1'}}</span>
            <button type="button" id="nextPageButton" class="sap-icon" (click)="onPage(true)" [disabled]="currentPage >= totalPages">
              &#xe066;
            </button>
            <button type="button" id="lastPageButton" class="sap-icon" [disabled]="currentPage >= totalPages || totalNumberOfRecords <= filter.pager.itemsPerPage" (click)="onFirstLastPage(false)">
              &#xe14a;
            </button>
          </div>
        </div>
        <!-- Pager END -->
      }
    </ng-template>
  </ngx-datatable-footer>
</ngx-datatable>

<!-- CELL TEMPLATES -->
<ng-template #defaultCellTmpl let-value="value.toString()" let-rowIndex="rowIndex" let-column="column" let-row='row'>
  @if (!column.editable) {
    <span class="ellipsis-cell-wrapper">
      <div class="text-cell" [matTooltip]=" column.type === columnType.Date ? (value | userDate) : column.type === columnType.DateTime ? (value | userDateTime:'time') : (value?.length > 1000 ? (value | slice:0:1000) + '…' : value)"
        matTooltipPosition="below" [matTooltipDisabled]="value.length < 20">
        @switch (column.type) {
          @case (columnType.Date) {
            {{ value | userDate }}
          }
          @case (columnType.DateTime) {
            {{ value | userDateTime:'time' }}
          }
          @default {
            {{ value }}
          }
        }
      </div>
    </span>
  }

  @if (column.editable) {
    <div class="input-error-cells">
      @switch (column.type) {
        @case (columnType.Number) {
          <span>
            <cpq-input-error #name="ngModel" [control]='name' [name]="tableId + '_' + column.name + '_' + rowIndex" width="100px"
              [(ngModel)]="row[column.prop]" (ngModelChange)='changed(row, column.prop)' (focusout)="onFocusOutEvent(row)" (keyup)="onKeyUp($event, row, column)"
              [cpqRequired]="column.required" [config]='column.formulaBuilderConfig' cpqNumber [cpqNumberOptions]='column.numberOptions'>
            </cpq-input-error>
          </span>
        }
        @case (columnType.Dropdown) {
          <span>
            <cpq-select #name="ngModel" [control]='name' [name]="tableId + '_' + column.name + '_' + rowIndex"
              [items]="column.items" [(ngModel)]="row[column.prop]" [disabled]="!column.editable" (change)="changed(row, column.prop)" >
            </cpq-select>
          </span>
        }
        @case (columnType.DatePicker) {
          <span>
            <cpq-date-picker #name="ngModel"
              [control]="name"
            [(ngModel)]="row[column.prop]" (ngModelChange)='changed(row, column.prop)'></cpq-date-picker>
          </span>
        }
        @default {
          <span>
            <cpq-input-error #name="ngModel" [control]='name' [name]="tableId + '_' + column.name + '_' + rowIndex" width="100px" type="text" [(ngModel)]="row[column.prop]" (ngModelChange)='changed(row, column.prop)' (focusout)="onFocusOutEvent(row)"
              [cpqRequired]="column.required"
              [maxlength]="column.maxLength"
              [config]='column.formulaBuilderConfig'>
            </cpq-input-error>
          </span>
        }
      }
    </div>
  }
</ng-template>

<ng-template #toggleCellTmpl let-rowIndex="rowIndex" let-row="row" let-column="column">
  <cpq-toggle [name]="tableId + '_' + column.name + '_' + rowIndex" [(ngModel)]="row[column.prop]" [disabled]="!column.editable" (change)="changed(row, column.prop)"></cpq-toggle>
</ng-template>

<ng-template #twoStateCellTmpl let-column="column" let-row="row">
  <span class="text-cell">{{row[column.prop] ? ('Msg.Yes' | translate) : ('Msg.No' | translate)}}</span>
</ng-template>

<ng-template #checkboxCellTmpl let-row="row" let-column="column">
  <mat-checkbox [(ngModel)]="row[column.prop]" (change)="changed(row, column.prop)" [disabled]="!column.editable"></mat-checkbox>
</ng-template>

<!-- CELL TEMPLATES END -->


<!-- HEADER TEMPLATES -->
<ng-template #headerLabelTmpl let-column="column" let-sort="sortFn" let-sortDir="sortDir">
  <span (click)="sort($event, sortDir)" class="datatable-header-cell-wrapper">
    <span class="datatable-header-cell-label draggable ellipsis" [attr.title]="column.name">{{ column.name }}</span>
  </span>
  @if (column.columnSearchInfoMessageKey) {
    <cpq-info class="cpq-info-icon column-search-info" [message]="{key: column.columnSearchInfoMessageKey}"></cpq-info>
  }
</ng-template>

<ng-template #defaultHeaderTemplate let-column="column" let-sort="sortFn" let-sortDir="sortDir">
  <!-- Headers -->
  @if (!showColumnSearchFields) {
    <ng-container *ngTemplateOutlet="column.customHeaderTemplate ? column.customHeaderTemplate : headerLabelTmpl; context: { column: column, sortFn: sort, sortDir: sortDir }"></ng-container>
  }

  <!-- Filters -->
  @if (showColumnSearchFields) {
    <ng-container *ngTemplateOutlet="column.customHeaderTemplate ? column.customHeaderTemplate : headerLabelTmpl; context: { column: column, sortFn: sort, sortDir: sortDir }">
    </ng-container>
    @switch (column.searchFieldType) {
      @case (ColumnSearchFieldType.twoState) {
        @if (showColumnSearchFields) {
          <div class="custom-datatable-header">
            <cpq-select #twoStateSelectComponent [disabled]="column.columnSearchDisabled" [id]="column.prop" [(ngModel)]='column.searchValue' [name]="column.label" [items]="yesNoSelectItems" [label]="{ key: '' }" (ngModelChange)='onColumnSearch(column, twoStateSelectComponent.items)' [setFirstOptionSelected]="false" [showEmptySelection]="true" [tabindex]="-1"></cpq-select>
          </div>
        }
      }
      @case (ColumnSearchFieldType.select) {
        @if (showColumnSearchFields) {
          <div class="custom-datatable-header">
            <cpq-select #selectStaticComponent [disabled]="column.columnSearchDisabled" [id]="column.prop" [(ngModel)]='column.searchValue' [name]="column.label" [items]="column.columnSearchItems" [label]="{ key: '' }"
            (ngModelChange)='onColumnSearch(column, selectStaticComponent.items)' [setFirstOptionSelected]="false" [showEmptySelection]="true" [tabindex]="-1"></cpq-select>
          </div>
        }
      }
      @case (ColumnSearchFieldType.searchableSelect) {
        @if (showColumnSearchFields) {
          <div class="custom-datatable-header">
            <cpq-select #selectSearchableComponent [type]="SelectType.AsyncSearchable" [url]="column.url" [disabled]="column.columnSearchDisabled" [id]="column.prop" [(ngModel)]='column.searchValue' [name]="column.label" [label]="{ key: '' }"
            (ngModelChange)='onColumnSearch(column, selectSearchableComponent.items)' [setFirstOptionSelected]="false" [tabindex]="-1"></cpq-select>
          </div>
        }
      }
      @case (ColumnSearchFieldType.date) {
        @if (showColumnSearchFields) {
          <div class="custom-datatable-header input-group date-filter"
            [matMenuTriggerFor]="menu" (menuOpened)="onDateFilterMenuOpen()" (menuClosed)="applyDateFilters(column)">
            <cpq-input [(ngModel)]="column.searchValue" [type]="'text'" [name]="column.prop" [tabindex]="-1" [disabled]='true'></cpq-input>
            <span class="sap-icon flex-center">&#xe076;</span>
          </div>
        }
        <mat-menu #menu="matMenu" xPosition="before">
          <div class='date-picker-popover-container' (click)="$event.stopPropagation()" (keydown.tab)="$event.stopPropagation()" (keydown.shift.tab)="$event.stopPropagation()">
            <cpq-toggle [(ngModel)]="column.isSearchByPeriod" [name]="'searchByPeriod'" [label]="{ key: 'xsltSearchByPeriod' }" (ngModelChange)="onSearchByDateChange($event, column)"></cpq-toggle>
            <cpq-date-picker #date="ngModel" [label]="{ key: column.isSearchByPeriod ? 'xsltDateFrom' : 'xsltDate' }" [control]="date"
              [ngModel]="column.dateFromSearchValue" (ngModelChange)="column.dateFromSearchValue=$event" [name]="'dateTo'" [id]="'dateFromInputField'"
            (keyup.enter)="applyDateFilters(column)" (blur)="applyDateFilters(column)" (onDatepickerClose)="applyDateFilters(column)"></cpq-date-picker>
            @if (column.isSearchByPeriod) {
              <cpq-date-picker #date="ngModel" [label]="{ key: 'xsltDateTo' }" [control]="date"
                [ngModel]="column.dateToSearchValue" (ngModelChange)="column.dateToSearchValue=$event" [name]="'dateFrom'" [id]="'dateToInputField'"
              (keyup.enter)="applyDateFilters(column)" (blur)="applyDateFilters(column)" (onDatepickerClose)="applyDateFilters(column)"></cpq-date-picker>
            }
          </div>
        </mat-menu>
      }
      @case (ColumnSearchFieldType.number) {
        @if (showColumnSearchFields) {
          <div class="custom-datatable-header">
            <cpq-input [disabled]="column.columnSearchDisabled" [(ngModel)]="column.searchValue" [type]="'number'" [name]="column.prop" [label]="{ key: '' }" [showSearchIcon]="true" [tabindex]="-1" (ngModelChange)="onColumnSearch(column)"></cpq-input>
          </div>
        }
      }
      @case (ColumnSearchFieldType.text) {
        @if (showColumnSearchFields) {
          <div class="custom-datatable-header">
            <cpq-input [disabled]="column.columnSearchDisabled" [(ngModel)]="column.searchValue" [type]="'text'" [name]="column.prop" [label]="{ key: '' }" [showSearchIcon]="true" [tabindex]="-1" (ngModelChange)="onColumnSearch(column)"></cpq-input>
          </div>
        }
      }
      @default {
      }
    }
  }
</ng-template>
<!-- HEADER TEMPLATES END -->

<!-- QUICK FILTER TEMPLATE -->
<ng-template #quickFilterTemplate>
  <div class="elements-holder flex-container filter">
    <div class="filter-group fiori3-input-group">
      <input type="text" class="quick-search-input form-control default" placeholder="{{ (filter.placeholder ? filter.placeholder : 'Msg.QuickFilter') | translate }}"
        [formControl]="searchControl" [size]="filter.placeholder && (filter.placeholder | translate).length" (keypress)="preventEnterKey($event)" id="datatableQuickFilter">
        <span class="input-group-icon">
          <button type="button" class="btn btn-default btn-main removeOutlineOnFocus" (click)='resetQuickFilter()'>
            @if (filter.quickFilter) {
              <span class="sap-icon">&#xe03e;</span>
            }
          </button>
          @if (!filter.quickFilter) {
            <span class="sap-icon">&#xe076;</span>
          }
        </span>
      </div>
    </div>
  </ng-template>
  <!-- QUICK FILTER TEMPLATE END -->
